import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5648d6de"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "carousel-box"
};
const _hoisted_2 = ["src"];

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 您的浏览器不支持Video标签。 ");

const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  const _component_el_carousel_item = _resolveComponent("el-carousel-item");

  const _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock("div", null, [_ctx.swiperList[0] != null ? (_openBlock(), _createBlock(_component_el_carousel, {
    key: 0,
    width: "1760px",
    "indicator-position": "none",
    interval: _ctx.cutTime,
    onChange: _ctx.getIndex
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.swiperList, item => {
      return _openBlock(), _createBlock(_component_el_carousel_item, {
        height: "auto",
        key: item
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_ctx.fileExt(item.fileUrl).toLowerCase() == 'jpg' || _ctx.fileExt(item.fileUrl).toLowerCase() == 'png' || _ctx.fileExt(item.fileUrl).toLowerCase() == 'gif' ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          src: _ctx.imgUrl(item.fileUrl),
          ref_for: true,
          ref: _ctx.getCarou,
          class: "swiper-img"
        }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("video", {
          key: 1,
          ref_for: true,
          ref: _ctx.getCarou,
          autoplay: "",
          muted: ""
        }, [_createElementVNode("source", {
          src: _ctx.imgUrl(item.fileUrl),
          type: "video/mp4"
        }, null, 8, _hoisted_2), _hoisted_3], 512)), _createElementVNode("div", {
          class: _normalizeClass([item.displayType == '1' ? 'title title1' : '', item.displayType == '2' ? 'title title2' : '', item.displayType == '3' ? 'title title3' : '', item.displayType == '4' ? 'title title4' : ''])
        }, [_createElementVNode("div", {
          class: _normalizeClass([item.titleBackgroundEnable ? 'text text-padding' : 'text']),
          style: _normalizeStyle({
            color: item.titleColor,
            backgroundColor: item.titleBackgroundEnable ? item.titleBackground : '',
            fontSize: item.titleSize == '1' ? '18px' : item.titleSize == '2' ? '20px' : item.titleSize == 3 ? '50px' : ''
          })
        }, _toDisplayString(item.title), 7), item.subtitle ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([item.subtitleBackgroundEnable ? 'text text-padding' : 'text']),
          style: _normalizeStyle({
            color: item.subtitleColor,
            backgroundColor: item.subtitleBackgroundEnable ? item.subtitleBackground : '',
            fontSize: item.subtitleSize == '1' ? '18px' : item.subtitleSize == '2' ? '20px' : item.subtitleSize == 3 ? '50px' : ''
          })
        }, _toDisplayString(item.subtitle), 7)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass([item.describeBackgroundEnable ? 'text text-padding' : 'text']),
          style: _normalizeStyle({
            color: item.describeColor,
            backgroundColor: item.describeBackgroundEnable ? item.describeBackground : '',
            fontSize: item.describeSize == '1' ? '18px' : item.describeSize == '2' ? '20px' : item.describeSize == 3 ? '50px' : ''
          })
        }, _toDisplayString(item.describe), 7), item.buttonEnable ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "banner-btn",
          style: _normalizeStyle({
            color: item.buttonTextColor,
            backgroundColor: item.buttonColor
          }),
          onClick: $event => _ctx.goImg(item.buttonLink)
        }, _toDisplayString(item.buttonName), 13, _hoisted_4)) : _createCommentVNode("", true)], 2)])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["interval", "onChange"])) : _createCommentVNode("", true)]);
}